export default {"src":"/_next/static/media/legalWork_40.764056cc.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};